module.exports = __webpack_public_path__ + "static/gas_fees_en_bg@2x-da3af56c18f07890622969ab80155fb4.png";